import { createSelector } from '@reduxjs/toolkit';

import { Announcement } from '@breathelife/types';

import { PublishedAnnouncementsState } from './AnnouncementsSlice';
import { LeadPlatformStore } from '../types';

export const getPublishedAnnouncementsState = (state: LeadPlatformStore): PublishedAnnouncementsState =>
  state.leadPlatform.publishedAnnouncements;

export const getPublishedAnnouncements = createSelector(
  getPublishedAnnouncementsState,
  (state): Announcement[] => state.announcements,
);

export const getPublishedAnnouncementsIsFetching = createSelector(
  getPublishedAnnouncementsState,
  (state): boolean => state.isFetching,
);
